var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.active)?_c('div',{staticClass:"zo-loader"},[_c('v-progress-circular',{attrs:{"rotate":360,"size":_vm.spinnerSize,"width":5,"indeterminate":"","color":"#005b98"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }